import React from 'react';

export default function BookmarkIcon() {
  return (
    <svg
      className="svg-icon"
      width="41px"
      height="35px"
      viewBox="0 0 41 35"
      role="img"
      aria-labelledby="bookmark-icon-title"
    >
      <title id="bookmark-icon-title">Bookmark icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path d="M8 0C6.895 0 6 0.895 6 2V33C6 33.552 6.448 34 7 34C7.237 34 7.465 33.916 7.646 33.763L20.5 23.267L33.354 33.763C33.535 33.916 33.763 34 34 34C34.552 34 35 33.552 35 33V2C35 0.895 34.105 0 33 0H8Z" />
        </g>
      </g>
    </svg>
  );
}
